<!-- 平台管理 - 服务对象管理 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div
                class="admin-content"
                :style="{ minHeight: adminContentMinHeight + 'px' }"
            >
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 全部服务对象</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form
                            ref="serviceTargetQueryForm"
                            :model="serviceTargetQueryForm"
                        >
                            <el-row :gutter="20">
                                <el-col :span="5" :offset="2">
                                    <el-form-item prop="targetName">
                                        <el-input
                                            v-model="
                                                serviceTargetQueryForm.targetName
                                            "
                                            :maxlength="100"
                                            placeholder="服务对象名称"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="plateNumber">
                                        <el-input
                                            v-model="
                                                serviceTargetQueryForm.plateNumber
                                            "
                                            :maxlength="100"
                                            placeholder="车牌号码"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="serviceType">
                                        <el-select
                                            v-model="
                                                serviceTargetQueryForm.serviceType
                                            "
                                            clearable
                                            placeholder="服务类型"
                                            class="el-full-width"
                                        >
                                            <el-option
                                                label="汽车服务"
                                                :value="1"
                                            ></el-option>
                                            <el-option
                                                label="市场营销"
                                                :value="2"
                                            ></el-option>
                                            <el-option
                                                label="车辆安全检测"
                                                :value="3"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item class="el-align-center">
                                        <el-button
                                            @click="resetServiceTargetQueryForm"
                                            icon="fas fa-undo"
                                            >重 置</el-button
                                        >&nbsp;&nbsp;&nbsp;&nbsp;
                                        <el-button
                                            type="primary"
                                            @click="
                                                queryServiceTargetList(1000)
                                            "
                                            icon="fas fa-search"
                                            >查 询</el-button
                                        >
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-toolbar">
                        <el-button-group>
                            <el-button
                                type="primary"
                                size="small"
                                icon="fas fa-plus-circle"
                                @click="openServiceTargetEditDialog('add')"
                                >添加对象</el-button
                            >
                            <el-button
                                type="primary"
                                size="small"
                                icon="fas fa-upload"
                                @click="openServiceTargetImportDialog()"
                                >批量导入</el-button
                            >
                            <el-button
                                type="primary"
                                size="small"
                                icon="fas fa-minus-circle"
                                @click="batchDeleteServiceTargets()"
                                >批量删除</el-button
                            >
                        </el-button-group>
                    </div>
                    <div class="el-search-list">
                        <el-table
                            ref="serviceTargetTable"
                            v-loading="serviceTargetQueryLoading"
                            element-loading-text="拼命加载中..."
                            element-loading-custom-class="el-loading-mask-opacity"
                            :class="{ loading: serviceTargetQueryLoading }"
                            :data="serviceTargetList"
                            :default-sort="serviceTargetQuerySort"
                            @sort-change="onServiceTargetQuerySortChange"
                            @selection-change="onServiceTargetSelectionChange"
                            style="width: 100%"
                            class="el-table-overflow-x-hidden"
                            empty-text="暂无数据"
                        >
                            <el-table-column
                                type="selection"
                                width="60"
                            ></el-table-column>
                            <el-table-column
                                label="#"
                                type="index"
                                width="50"
                            ></el-table-column>
                            <el-table-column
                                label="服务对象名称"
                                prop="targetName"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="服务类型"
                                prop="serviceType"
                                width="150"
                                sortable
                            >
                                <template slot-scope="scope">
                                    <span>{{ scope.row.serviceTypeName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="车牌号码"
                                prop="plateNumber"
                                width="100"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="品牌型号"
                                prop="vehicleModel"
                                width="200"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="车架号"
                                prop="vehicleVin"
                                width="250"
                                align="center"
                            ></el-table-column>
                            <el-table-column
                                label="创建时间"
                                prop="createTime"
                                width="100"
                                align="center"
                                sortable
                            ></el-table-column>
                            <el-table-column
                                label="操作"
                                width="140"
                                align="center"
                            >
                                <template slot-scope="scope">
                                    <el-button
                                        type="text"
                                        @click="
                                            openServiceTargetViewDialog(
                                                'view',
                                                scope.row
                                            )
                                        "
                                        >查看详情</el-button
                                    >
                                    <el-dropdown
                                        size="small"
                                        trigger="click"
                                        @command="
                                            handleServiceTargetCommand(
                                                arguments[0],
                                                scope.row
                                            )
                                        "
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="el-icon-arrow-down el-icon--right"
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="view"
                                                >查看详情</el-dropdown-item
                                            >
                                            <el-dropdown-item command="edit"
                                                >修改对象</el-dropdown-item
                                            >
                                            <el-dropdown-item
                                                command="delete"
                                                divided
                                                >删除对象</el-dropdown-item
                                            >
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination
                            background
                            v-show="showServiceTargetQueryPager"
                            @current-change="
                                onServiceTargetQueryCurrentPageChange
                            "
                            :current-page.sync="
                                serviceTargetQueryForm.currentPage
                            "
                            :page-size="serviceTargetQueryForm.pageSize"
                            layout="slot, prev, pager, next, total"
                            :total="serviceTargetQueryTotal"
                        >
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button
                                        :class="{
                                            active:
                                                serviceTargetQueryForm.pageSize ==
                                                10,
                                        }"
                                        @click="
                                            onServiceTargetQueryPageSizeChange(
                                                10
                                            )
                                        "
                                        >10</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                serviceTargetQueryForm.pageSize ==
                                                20,
                                        }"
                                        @click="
                                            onServiceTargetQueryPageSizeChange(
                                                20
                                            )
                                        "
                                        >20</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                serviceTargetQueryForm.pageSize ==
                                                50,
                                        }"
                                        @click="
                                            onServiceTargetQueryPageSizeChange(
                                                50
                                            )
                                        "
                                        >50</el-button
                                    >
                                    <el-button
                                        :class="{
                                            active:
                                                serviceTargetQueryForm.pageSize ==
                                                100,
                                        }"
                                        @click="
                                            onServiceTargetQueryPageSizeChange(
                                                100
                                            )
                                        "
                                        >100</el-button
                                    >
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 添加/修改Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="serviceTargetEditDialogVisible"
                        @closed="closeServiceTargetEditDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            {{ serviceTargetEditDialogTitle }}</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                ref="serviceTargetEditForm"
                                :model="serviceTargetEditForm"
                                :rules="serviceTargetEditRules"
                                label-width="300px"
                            >
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="服务对象名称"
                                            prop="targetName"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        serviceTargetEditForm.targetName
                                                    "
                                                    :maxlength="50"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    2~50个汉字、字母、数字及下划线组成.
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="服务类型"
                                            prop="serviceType"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        serviceTargetEditForm.serviceType
                                                    "
                                                    clearable
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        label="汽车服务"
                                                        :value="1"
                                                    ></el-option>
                                                    <el-option
                                                        label="市场营销"
                                                        :value="2"
                                                    ></el-option>
                                                    <el-option
                                                        label="车辆安全检测"
                                                        :value="3"
                                                    ></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="车牌号码"
                                            prop="plateNumber"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        serviceTargetEditForm.plateNumber
                                                    "
                                                    :maxlength="10"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    例如：京A88888
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="车辆品牌型号"
                                            prop="vehicleModel"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        serviceTargetEditForm.vehicleModel
                                                    "
                                                    :maxlength="50"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="车架号"
                                            prop="vehicleVin"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        serviceTargetEditForm.vehicleVin
                                                    "
                                                    :maxlength="50"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="发动机号码"
                                            prop="engineNumber"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        serviceTargetEditForm.engineNumber
                                                    "
                                                    :maxlength="50"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="车辆座位数"
                                            prop="vehicleSeats"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        serviceTargetEditForm.vehicleSeats
                                                    "
                                                    :maxlength="10"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    例如：7座|5座
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="车辆使用性质"
                                            prop="vehicleUseProperty"
                                        >
                                            <el-col :span="12">
                                                <el-input
                                                    v-model="
                                                        serviceTargetEditForm.vehicleUseProperty
                                                    "
                                                    :maxlength="50"
                                                ></el-input>
                                            </el-col>
                                            <el-col :span="12">
                                                <p class="el-form-item-tips">
                                                    例如：私家车|公车
                                                </p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="车辆初登日期"
                                            prop="vehicleRegisterDate"
                                        >
                                            <el-col :span="12">
                                                <el-date-picker
                                                    v-model="
                                                        serviceTargetEditForm.vehicleRegisterDate
                                                    "
                                                    format="yyyy-MM-dd"
                                                    value-format="yyyy-MM-dd"
                                                    :picker-options="
                                                        beforeNowPickerOptions
                                                    "
                                                ></el-date-picker>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeServiceTargetEditDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="saveServiceTarget"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 导入Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="serviceTargetImportDialogVisible"
                        @closed="closeServiceTargetImportDialog"
                    >
                        <span slot="title" class="el-drawer-title"
                            >批量导入服务对象</span
                        >
                        <div class="el-drawer-content">
                            <el-form
                                class="el-drawer-content-body"
                                v-custom-validator-apply="
                                    serviceTargetImportRules
                                "
                                ref="serviceTargetImportForm"
                                :model="serviceTargetImportForm"
                                :rules="serviceTargetImportRules"
                                label-width="300px"
                            >
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="服务对象类型"
                                            prop="serviceType"
                                        >
                                            <el-col :span="12">
                                                <el-select
                                                    v-model="
                                                        serviceTargetImportForm.serviceType
                                                    "
                                                    clearable
                                                    class="el-full-width"
                                                >
                                                    <el-option
                                                        label="汽车服务"
                                                        :value="1"
                                                    ></el-option>
                                                    <el-option
                                                        label="市场营销"
                                                        :value="2"
                                                    ></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item
                                            label="上传EXCEL文件"
                                            prop="uploadExcelFilePath"
                                        >
                                            <el-col :span="12">
                                                <el-upload
                                                    class="upload-excel"
                                                    ref="serviceTargetImportUploader"
                                                    name="uploadFile"
                                                    :multiple="false"
                                                    :limit="1"
                                                    :on-exceed="
                                                        handleImportExcelExceed
                                                    "
                                                    :headers="uploadHeaders"
                                                    :action="
                                                        importExcelUploadUrl
                                                    "
                                                    :data="
                                                        importExcelUploadParam
                                                    "
                                                    :before-upload="
                                                        beforeImportExcelUpload
                                                    "
                                                    :on-remove="
                                                        handleImportExcelRemove
                                                    "
                                                    :on-success="
                                                        handleImportExcelUploadSuccess
                                                    "
                                                    :on-error="
                                                        handleUploadError
                                                    "
                                                >
                                                    <el-button
                                                        slot="trigger"
                                                        size="small"
                                                        type="primary"
                                                        icon="fas fa-plus-circle"
                                                        >选择文件</el-button
                                                    >
                                                    <a
                                                        class="excel-template"
                                                        href="javascript:;"
                                                        @click="
                                                            downloadTemplateExcel
                                                        "
                                                        >下载模板</a
                                                    >
                                                    <div
                                                        class="el-upload__tip"
                                                        slot="tip"
                                                    >
                                                        只能上传xls|xlsx格式的EXCEL文件，大小不超过1MB!
                                                    </div>
                                                </el-upload>
                                                <div
                                                    v-if="
                                                        showServiceTargetImportFeedback
                                                    "
                                                >
                                                    <p class="import-feedback">
                                                        上传EXCEL中部分数据校验不通过，请点此<a
                                                            href="javascript:;"
                                                            @click="
                                                                downloadFeedbackExcel
                                                            "
                                                            >链接下载</a
                                                        >反馈信息予以更正并重新上传导入.
                                                    </p>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <p
                                                    class="el-form-item-tips"
                                                ></p>
                                            </el-col>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeServiceTargetImportDialog"
                                    >取 消</el-button
                                >
                                <el-button
                                    type="primary"
                                    icon="far fa-save"
                                    @click="importServiceTarget"
                                    :loading="submiting"
                                    >确 定</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>

                    <!-- 查看Dialog -->
                    <el-drawer
                        size="70%"
                        :visible.sync="serviceTargetViewDialogVisible"
                        @closed="closeServiceTargetViewDialog"
                    >
                        <span slot="title" class="el-drawer-title">
                            查看服务对象详情</span
                        >
                        <div class="el-drawer-content">
                            <div class="el-drawer-content-body">
                                <el-form
                                    class="el-form-detail"
                                    inline
                                    label-position="right"
                                    label-width="120px"
                                    label-suffix="："
                                >
                                    <el-form-item label="服务对象ID">{{
                                        serviceTargetViewForm.targetId
                                    }}</el-form-item>
                                    <el-form-item label="服务对象名称">{{
                                        serviceTargetViewForm.targetName
                                    }}</el-form-item>

                                    <el-form-item
                                        label="服务对象类型"
                                        style="width: 100%"
                                        >{{
                                            serviceTargetViewForm.serviceTypeName
                                        }}</el-form-item
                                    >

                                    <el-form-item label="车牌号码">{{
                                        serviceTargetViewForm.plateNumber
                                    }}</el-form-item>
                                    <el-form-item label="车架号">{{
                                        serviceTargetViewForm.vehicleVin
                                    }}</el-form-item>

                                    <el-form-item label="发动机号码">{{
                                        serviceTargetViewForm.engineNumber
                                    }}</el-form-item>
                                    <el-form-item label="车辆座位数">{{
                                        serviceTargetViewForm.vehicleSeats
                                    }}</el-form-item>

                                    <el-form-item label="车辆使用性质">{{
                                        serviceTargetViewForm.vehicleUseProperty
                                    }}</el-form-item>
                                    <el-form-item label="车辆初登日期">{{
                                        serviceTargetViewForm.vehicleRegisterDate
                                    }}</el-form-item>

                                    <el-form-item label="创建时间">{{
                                        serviceTargetViewForm.createTime
                                    }}</el-form-item>
                                    <el-form-item label="修改时间">{{
                                        serviceTargetViewForm.updateTime
                                    }}</el-form-item>
                                </el-form>
                            </div>
                            <div class="el-drawer-content-footer">
                                <el-button
                                    icon="fas fa-ban"
                                    @click="closeServiceTargetViewDialog"
                                    >关 闭</el-button
                                >
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort, parseFilename } from '@/utils.js';
import FileSaver from 'file-saver';

const EXCEL_TYPES = ['xls', 'xlsx'];

export default {
    name: 'ServiceTarget',
    data() {
        return {
            submiting: false,
            serviceTargetList: [],
            serviceTargetQueryLoading: false,
            serviceTargetQuering: false,
            serviceTargetQueryForm: {
                targetName: '',
                serviceType: '',
                plateNumber: '',
                pageSize: 10,
                currentPage: 1,
            },
            serviceTargetQueryTotal: 0,
            serviceTargetQuerySort: {
                prop: 'createTime',
                order: 'descending',
            },
            currentActionType: 'add',
            serviceTargetEditDialogVisible: false,
            serviceTargetViewDialogVisible: false,
            serviceTargetImportDialogVisible: false,
            serviceTargetEditForm: {
                targetId: '',
                targetName: '',
                serviceType: '',
                plateNumber: '',
                vehicleModel: '',
                engineNumber: '',
                vehicleSeats: '',
                vehicleVin: '',
                vehicleUseProperty: '',
                vehicleRegisterDate: '',
            },
            serviceTargetEditRules: {
                targetName: [
                    {
                        required: true,
                        message: '请输入服务对象名称!',
                    },
                    {
                        pattern: /^[a-zA-Z\u00a1-\uffff0-9_]{2,50}$/,
                        message:
                            '服务对象名称由2~50个汉字、字母、数字及下划线组成!',
                    },
                ],
                serviceType: [
                    {
                        required: true,
                        type: 'number',
                        message: '请选择服务类型!',
                    },
                ],
                plateNumber: [
                    {
                        required: true,
                        message: '请输入车牌号码!',
                    },
                ],
            },
            importExcelUploadUrl: PLATFORM_API.of(
                '/api/xupload/protected/file'
            ),
            importExcelUploadParam: {
                renameStrategy: 'ORIGINAL_FILENAME_AND_UUID',
                formatLimit: EXCEL_TYPES.join(','),
            },
            serviceTargetImportForm: {
                serviceType: '',
                uploadExcelFileName: '',
                uploadExcelFilePath: '',
            },
            serviceTargetImportRules: {
                serviceType: [
                    {
                        required: true,
                        type: 'number',
                        message: '请选择服务对象类型!',
                    },
                ],
                uploadExcelFilePath: [
                    {
                        required: true,
                        message: '请选择导入Excel文件!',
                    },
                ],
            },
            showServiceTargetImportFeedback: false,
            serviceTargetViewForm: {
                targetId: '',
                targetName: '',
                serviceType: '',
                serviceTypeName: '',
                plateNumber: '',
                vehicleModel: '',
                engineNumber: '',
                vehicleSeats: '',
                vehicleVin: '',
                vehicleUseProperty: '',
                vehicleRegisterDate: '',
                createBy: '',
                createTime: '',
                updateBy: '',
                updateTime: '',
            },
            beforeNowPickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            batchDeleteServiceTargetIds: [],
        };
    },
    computed: {
        showServiceTargetQueryPager() {
            if (
                this.serviceTargetQuering ||
                this.serviceTargetQueryTotal == 0
            ) {
                return false;
            } else {
                return true;
            }
        },
        serviceTargetEditDialogTitle() {
            if (this.currentActionType == 'add') {
                return '添加服务对象';
            } else if (this.currentActionType == 'edit') {
                return '修改服务对象';
            } else {
                return '';
            }
        },
        uploadHeaders() {
            let headers = {
                Accept: 'application/json',
            };
            let accessToken = this.$store.getters.getAccessToken();
            if (accessToken && accessToken.access_token) {
                headers['Authorization'] = 'bearer ' + accessToken.access_token;
            }
            return headers;
        },
    },
    created() {},
    mounted() {
        this.queryServiceTargetList(1000);
    },
    methods: {
        queryServiceTargetList(loading) {
            this.serviceTargetQueryForm.currentPage = 1;
            this.doQueryServiceTargetList(loading);
        },
        doQueryServiceTargetList(loading) {
            this.serviceTargetQuering = true;
            if (loading) {
                this.serviceTargetQueryLoading = true;
            }
            setTimeout(() => {
                let params = Object.assign(
                    {},
                    this.serviceTargetQueryForm,
                    mapSort(this.serviceTargetQuerySort)
                );
                this.$http
                    .get(
                        PLATFORM_API.of(
                            '/api/platform/visp/servicetarget/list'
                        ),
                        {
                            params: params,
                        }
                    )
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.serviceTargetList = result.data;
                            this.serviceTargetQueryTotal = result.totalRowCount;
                        } else {
                            this.serviceTargetList = [];
                            this.serviceTargetQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch((error) => {
                        this.serviceTargetList = [];
                        this.serviceTargetQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.serviceTargetQueryLoading = false;
                        }
                        this.serviceTargetQuering = false;
                    });
            }, loading);
        },
        resetServiceTargetQueryForm() {
            this.$refs.serviceTargetQueryForm.resetFields();
        },
        onServiceTargetSelectionChange(selectedRows) {
            if (selectedRows && selectedRows.length) {
                this.batchDeleteServiceTargetIds = [];
                selectedRows.forEach((row) => {
                    this.batchDeleteServiceTargetIds.push(row.targetId);
                });
            } else {
                this.batchDeleteServiceTargetIds = [];
            }
        },
        onServiceTargetQuerySortChange(parameter) {
            if (
                this.serviceTargetQuerySort.prop != parameter.prop ||
                this.serviceTargetQuerySort.order != parameter.order
            ) {
                this.serviceTargetQuerySort.prop = parameter.prop;
                this.serviceTargetQuerySort.order = parameter.order;
                this.queryServiceTargetList(1000);
            }
        },
        onServiceTargetQueryPageSizeChange(pageSize) {
            this.serviceTargetQueryForm.pageSize = pageSize;
            this.queryServiceTargetList(1000);
        },
        onServiceTargetQueryCurrentPageChange(currentPage) {
            this.serviceTargetQueryForm.currentPage = currentPage;
            this.doQueryServiceTargetList(1000);
        },
        handleServiceTargetCommand(cmd, row) {
            if (cmd == 'edit') {
                this.openServiceTargetEditDialog(cmd, row);
            } else if (cmd == 'view') {
                this.openServiceTargetViewDialog(cmd, row);
            } else if (cmd == 'delete') {
                this.deleteServiceTarget(row);
            }
        },
        openServiceTargetEditDialog(cmd, row) {
            this.currentActionType = cmd;
            this.serviceTargetEditDialogVisible = true;
            if (cmd == 'edit') {
                Vue.nextTick(() => {
                    Object.keys(this.serviceTargetEditForm).forEach((name) => {
                        let value = row[name];
                        this.serviceTargetEditForm[name] = value;
                    });
                });
            }
        },
        closeServiceTargetEditDialog() {
            this.submiting = false;
            this.serviceTargetEditDialogVisible = false;
            this.$refs.serviceTargetEditForm.resetFields();
            //手动reset
            this.serviceTargetEditForm.targetId = '';
        },
        openServiceTargetViewDialog(cmd, row) {
            this.currentActionType = cmd;
            this.serviceTargetViewDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.serviceTargetViewForm).forEach((name) => {
                    let value = row[name];
                    this.serviceTargetViewForm[name] = value;
                });
            });
        },
        closeServiceTargetViewDialog() {
            this.serviceTargetViewDialogVisible = false;
            Object.keys(this.serviceTargetViewForm).forEach((name) => {
                this.serviceTargetViewForm[name] = '';
            });
        },
        deleteServiceTarget(row) {
            let url = PLATFORM_API.of(
                '/api/platform/visp/servicetarget/delete/' + row.targetId
            );
            this.$confirm('您确定要删除该服务对象?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.$http
                    .delete(url)
                    .then((response) => {
                        let result = response.data;
                        if (result.success) {
                            this.$message.success(result.message);
                            this.queryServiceTargetList(1000);
                        } else {
                            this.$message.error(result.message);
                        }
                    })
                    .catch(defaultApiErrorHandler);
            });
        },
        saveServiceTarget() {
            let url = '';
            let method = 'post';
            if (this.currentActionType == 'add') {
                url = PLATFORM_API.of(
                    '/api/platform/visp/servicetarget/create'
                );
                method = 'post';
            } else if (this.currentActionType == 'edit') {
                url = PLATFORM_API.of(
                    '/api/platform/visp/servicetarget/update'
                );
                method = 'put';
            }
            if (url) {
                this.$refs.serviceTargetEditForm.validate((valid) => {
                    if (valid && !this.submiting) {
                        this.submiting = true;
                        setTimeout(() => {
                            this.$http[method](url, this.serviceTargetEditForm)
                                .then((response) => {
                                    let result = response.data;
                                    if (result.success) {
                                        this.closeServiceTargetEditDialog();
                                        this.$message.success(result.message);
                                        this.queryServiceTargetList(1000);
                                    } else {
                                        this.$message.error(result.message);
                                    }
                                })
                                .catch(defaultApiErrorHandler)
                                .then(() => {
                                    this.submiting = false;
                                });
                        }, 1500);
                    } else {
                        return false;
                    }
                });
            }
        },
        openServiceTargetImportDialog() {
            this.serviceTargetImportDialogVisible = true;
        },
        closeServiceTargetImportDialog() {
            this.serviceTargetImportDialogVisible = false;
            this.showServiceTargetImportFeedback = false;
            this.$refs.serviceTargetImportForm.resetFields();
            this.$refs.serviceTargetImportUploader.clearFiles();
        },
        batchDeleteServiceTargets() {
            if (this.batchDeleteServiceTargetIds.length) {
                let url = PLATFORM_API.of(
                    '/api/platform/visp/servicetarget/delete/batch'
                );
                this.$confirm('您确定要删除所选服务对象?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    this.$http
                        .post(url, this.batchDeleteServiceTargetIds)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.$message.success(result.message);
                                this.queryServiceTargetList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler);
                });
            } else {
                this.$message.error('请选择需要删除服务对象!');
            }
        },
        importServiceTarget() {
            let url = PLATFORM_API.of(
                '/api/platform/visp/servicetarget/import'
            );
            this.$refs.serviceTargetImportForm.validate((valid) => {
                if (valid && !this.submiting) {
                    this.submiting = true;
                    this.$http
                        .post(url, this.serviceTargetImportForm)
                        .then((response) => {
                            let result = response.data;
                            if (result.success) {
                                this.closeServiceTargetImportDialog();
                                this.$message.success(result.message);
                                this.queryServiceTargetList(1000);
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch((error) => {
                            defaultApiErrorHandler.call(
                                this,
                                error,
                                (result) => {
                                    if (result.code == 400) {
                                        this.showServiceTargetImportFeedback = true;
                                    }
                                }
                            );
                        })
                        .then(() => {
                            this.submiting = false;
                        });
                } else {
                    return false;
                }
            });
        },
        downloadTemplateExcel() {
            let url = PLATFORM_API.of('/api/xdownload/store/file');
            this.$http
                .post(
                    url,
                    {
                        targetFileName: '服务对象导入模板.xlsx',
                        targetFilePath:
                            '/excel/templates/服务对象导入模板.xlsx',
                    },
                    {
                        responseType: 'blob', // 设置响应数据类型
                    }
                )
                .then((response) => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler);
        },
        downloadFeedbackExcel() {
            let url = PLATFORM_API.of('/api/xdownload/temp/file');
            this.$http
                .post(
                    url,
                    {
                        targetFileName:
                            this.serviceTargetImportForm.uploadExcelFileName,
                        targetFilePath:
                            this.serviceTargetImportForm.uploadExcelFilePath,
                    },
                    {
                        responseType: 'blob', // 设置响应数据类型
                    }
                )
                .then((response) => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler);
        },
        beforeImportExcelUpload(file) {
            let fileName = file.name;
            if (fileName.replace(/\s+/g, '') != fileName) {
                this.$message.error('上传文件名不能包含空格!');
                return false;
            }
            let fileType = fileName
                .substring(fileName.lastIndexOf('.') + 1)
                .toLowerCase();
            if (EXCEL_TYPES.indexOf(fileType) == -1) {
                this.$message.error(
                    '上传文件只能是EXCEL(xls、xlsx)格式的文件!'
                );
                return false;
            }
            if (file.size > 0 && file.size / 1024 / 1024 > 1) {
                this.$message.error('上传EXCEL文件大小不能超过1MB!');
                return false;
            }
            return true;
        },
        handleImportExcelExceed(file, fileList) {
            this.$message.error('最多只能上传一个文件!若要重新上传请先删除.');
            return false;
        },
        handleImportExcelUploadSuccess(response, file, fileList) {
            file.path = response.data.path;
            this.serviceTargetImportForm.uploadExcelFileName =
                response.data.name;
            this.serviceTargetImportForm.uploadExcelFilePath =
                response.data.path;
            this.showServiceTargetImportFeedback = false;
            this.$refs.serviceTargetImportForm.validateField(
                'uploadExcelFilePath'
            );
        },
        handleImportExcelRemove(file, fileList) {
            this.serviceTargetImportForm.uploadExcelFileName = '';
            this.serviceTargetImportForm.uploadExcelFilePath = '';
            this.showServiceTargetImportFeedback = false;
            if (file && file.path) {
                this.$http.get(
                    PLATFORM_API.of(
                        '/api/xupload/protected/remove?path=' + file.path
                    )
                );
            }
        },
        handleUploadError(error, file, fileList) {
            try {
                let result = JSON.parse(error.message);
                this.$message.error(result.message);
            } catch (e) {
                console.error(e);
            }
        },
    },
};
</script>